import React, { useEffect, useState } from 'react'

export default function BookingPopup({ isOpen, onClose }) {
  const [hasOpened, setHasOpened] = useState(false);

  // Only load Survcart script and render iframe on first open
  useEffect(() => {
    if (!isOpen) return;
    if (!hasOpened) setHasOpened(true);

    // Only inject script once
    if (document.querySelector('script[src="https://embed.survcart.com/embed.js"]')) return;

    window.survcartConfig = {
      id: "R1zJhkIIHF6wPVuhrBoI",
      embedName: "Embed Configuration 1",
      staged: false,
      companyId: "MHZmpURzZElNL3iOdMS2",
      selectors: [
        {
          ga4_tags: [],
          id: "wbyGa6ZLtt4y2VuWfTSP",
          default: false,
          workflowId: "fnAS3LgAZ2xCtNWvX3ST",
          tokens: [""],
          classes: "survcart-embed-presenter",
          configId: "TPWHUYBLYhJNm5pOTGpI",
        },
      ],
    };

    const script = document.createElement("script");
    script.src = "https://embed.survcart.com/embed.js";
    script.async = true;
    document.body.appendChild(script);
  }, [isOpen]);

  return (
    <>
      <div className={`modal-boking fade booking-engine-popup ${isOpen ? "is-open-model" : ""}`}>
        <div className="form-overlay" onClick={onClose}></div>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="popup-model">
                <div className="engine-popup-inner">
                  {/* Only render iframe after first open to prevent Stripe/Survcart loading on page load */}
                  {hasOpened && (
                    <iframe
                      src="https://embed.survcart.com?type=landing&co=MHZmpURzZElNL3iOdMS2&wsid=R1zJhkIIHF6wPVuhrBoI&sel=wbyGa6ZLtt4y2VuWfTSP"
                      height="500"
                      style={{ width: "100%", border: "none" }}
                      title="Survcart Embed"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
